import dayjs from 'dayjs';
import router from '../../router';
import api from '../../api/index';
export default {
  namespaced: true,
  state     : {
    menu_showed    : false,
    calendar_showed: false,
    show_flag      : false,
    actual_date    : [],
    calendar_dates : [
      {
        id           : 0,
        type         : 'event',
        url          : '/news_descript/52',
        course_name  : 'Курс «Технология производства масел»',
        date_assigned: '05.06.2019',
        date_expired : '30.08.2019',
      },
    ],
  },
  getters: {
    actual_date    : ({actual_date}) => actual_date,
    show_flag      : ({show_flag}) => show_flag,
    menu_showed    : ({menu_showed}) => menu_showed,
    calendar_showed: ({calendar_showed}) => calendar_showed,
    calendar_dates : ({calendar_dates}) => calendar_dates,
  },
  mutations: {
    SET_ACTUAL_DATE(state, value) {
      state.actual_date.push(value);
    },
    SET_CALENDAR_DATES(state, value) {
      state.calendar_dates = value;
    },
    SHOW_MENU(state) {
      state.menu_showed = true;
    },
    HIDE_MENU(state) {
      state.menu_showed = false;
    },
    TOGGLE_MENU(state) {
      state.menu_showed = !state.menu_showed;
    },
    TOGGLE_CALENDAR(state) {
      state.calendar_showed = !state.calendar_showed;
    },
    OPEN_CALENDAR(state) {
      state.calendar_showed = true;
    },
    CLOSE_CALENDAR(state) {
      state.calendar_showed = false;
    },
    CHECK_DATE_FOR_VISUAL(state, value) {
      state.show_flag = value;
    },
    RESET_ACTUAL_DATES(state) {
      state.actual_date = [];
    },

  },
  actions: {
    async get_courses_calendar({commit}) {
      try {
        let calendar = await api.course.courses_calendar();
        commit('SET_CALENDAR_DATES', calendar.data);
      } catch (err) {
        if (err.message.indexOf('401')!=-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    check_date_for_use({getters, commit}, date) {
      let {calendar_dates} = getters;
      let from = null;
      let to = null;
      date = new Date(date.split('.')[2], date.split('.')[1]-1, date.split('.')[0]);
      calendar_dates.filter((item) => {
        from = new Date(item.date_assigned.split('.')[2], item.date_assigned.split('.')[1]-1, item.date_assigned.split('.')[0]);
        to = new Date(item.date_expired.split('.')[2], item.date_expired.split('.')[1]-1, item.date_expired.split('.')[0]);

        if ((new dayjs(date).isAfter(new dayjs(from)) || new dayjs(date).format('DD.MM.YYYY') == new dayjs(to).format('DD.MM.YYYY'))
            && (new dayjs(date).isBefore(new dayjs(to)) || new dayjs(date).format('DD.MM.YYYY') == new dayjs(from).format('DD.MM.YYYY'))
        ) {
          commit('CHECK_DATE_FOR_VISUAL', true);
          let actual_date = {
            id           : item.id,
            type         : item.type,
            url          : item.url,
            date_assigned: item.date_assigned,
            date_expired : item.date_expired,
            title        : item.course_name,
          };
          commit('SET_ACTUAL_DATE', actual_date);
          return;
        }
      });
    },
  },
};
